export default __webpack_public_path__ + "static/media/img_banner_desktop_rf.19aceb7f.jpg";